// Reseller: formularul pregătește un e-mail către adresa aleasă în editor.
(() => {
  if (window.__feRsForm) return;
  window.__feRsForm = true;
  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('form[data-fe-mailto]');
    if (!form) return;
    event.preventDefault();
    const to = form.dataset.feMailto;
    if (!to) return;
    const values = new FormData(form);
    const lines = [];
    values.forEach((v, k) => {
      if (k === 'contact[Consimtamant]' || k === 'contact[Sursa]' || !String(v).trim()) return;
      const field = form.elements[k];
      const label = field && field.closest ? field.closest('label') : null;
      const text = label ? [...label.childNodes].filter((n) => n.nodeType === 3).map((n) => n.textContent).join(' ').replace(/\*/g, '').replace(/\s+/g, ' ').trim() : '';
      lines.push((text || k.replace('contact[', '').replace(']', '')) + ': ' + v);
    });
    const subject = form.dataset.feSubject || 'Femieko';
    window.location.href = 'mailto:' + to + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(lines.join('\n\n'));
    const status = form.querySelector('[data-fe-form-status]');
    if (status) { status.hidden = false; status.textContent = form.dataset.feDone || ''; }
  });
})();
